import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { FilterComponentIcon } from './FilterComponentIcon';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Styles from './filtersComponent.module.scss';
import { TFunction } from 'i18next';

// TO DO ADD TO STORY BOOK
// STORY BOOK PROPS:
// Example Props Recieve:
// [
//   {
//       key: "MainCategoryFilter",
//       label: "Main Category",
//       // Filter options for this Filter Section
//       filters: [
//           {
//               key: ProductCategoryType.FOOD,
//               label: ProductCategoryType.FOOD,
//               checked: state.filterState.MainCategoryFilter.includes(ProductCategoryType.FOOD),
//           },
//           {
//               key: ProductCategoryType.DRINK,
//               label: ProductCategoryType.DRINK,
//               checked: state.filterState.MainCategoryFilter.includes(ProductCategoryType.DRINK),
//           },
//       ]
//   },
// ]

// OnSubmit Data Return:
//   when Both Food and Drink selected:
//   [
//     {
//       key:MainCategoryFilter,
//       values:[FOOD,DRINK]
//     }
//   ]

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: '1rem 2rem',
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
        HeaderTitle: {
            color: '#212121',
            fontWeight: 600,
            fontSize: '1.125rem',
        },
        ClearButton: {
            width: '3.875rem',
            height: '1.75rem',
            background: '#F3F4F9',
            borderRadius: '3.5rem',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '0.9375rem',
            outline: 'unset !important',
            border: 'unset',
            cursor: 'pointer',

            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '0.8125rem',
            lineHeight: '1.125rem',
            color: ' #212121',
        },
        FilterMainTitle: {
            fontSize: '0.875rem',
            color: '#757575',
        },
        FilterOptionLabel: {
            fontSize: '1rem',
            color: '#212121',
            marginBottom: '1.25rem',
        },
    });
export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}

export interface ClearFiltersButtonProps extends WithStyles<typeof styles> {
    filters: IFiltersList[];
    setFilters: (filters: IFiltersList[]) => void;
    t: TFunction;
}
const ClearFiltersButton = withStyles(styles)((props: ClearFiltersButtonProps) => {
    const { classes, filters, setFilters, t } = props;
    return (
        <Button
            onClick={() => {
                let newFilters = filters;
                newFilters.forEach((item) => {
                    item.filters.forEach((filterOption) => {
                        filterOption.checked = false;
                    });
                });
                setFilters([...newFilters]);
            }}
            data-component-name="CLEAR_BUTTON"
            className={classes.ClearButton}
        >
            {t('filters.clear')}
        </Button>
    );
});

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className={classes.HeaderTitle} variant="h6">
                {children}
            </Typography>
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
        minWidth: '320px',
        borderBottom: 'none',
    },
}))(MuiDialogContent);

interface FiltersProps {
    setFilterState: (filterState: any) => void;
    filterkey?: string;
    filterTitle?: string;
    filtersList: IFiltersList[];
}

export interface IFiltersList {
    key: string;
    label: string;
    filters: FilterOption[];
}

interface FilterOption {
    key: string;
    label: string;
    checked?: boolean;
}
const FilterComponent = ({ setFilterState, filterTitle, filterkey = 'filters', filtersList }: FiltersProps) => {
    const { t } = useTranslation();
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [filters, setFilters] = useState<IFiltersList[]>([]);
    useEffect(() => {
        if (filterkey) {
            if (localStorage.getItem(filterkey)) {
                setFilters(JSON.parse(localStorage.getItem(filterkey) as string));
                setFilterState(JSON.parse(localStorage.getItem(filterkey) as string));
                return;
            }
        }
        // eslint-disable-next-line
    }, [filterkey]);

    useEffect(() => {
        setFilters(filtersList);
    }, [filtersList]);

    const renderFilterCount = () => {
        let count = 0;
        filters.forEach((item) => {
            item.filters.forEach((filterOption) => {
                if (filterOption.checked) {
                    count++;
                }
            });
        });
        return count;
    };
    const CustomCheckbox = withStyles((theme) => ({
        root: {
            color: '#F3F4F9',
            '& .MuiIconButton-label': {
                position: 'relative',
                zIndex: 0,
            },
            '&:not($checked) .MuiIconButton-label:after': {
                content: '""',
                left: 2,
                top: 2,
                height: 20,
                width: 20,
                position: 'absolute',
                backgroundColor: '#F3F4F9',
                zIndex: -1,
                border: '1px solid',
                borderRadius: 4,
            },
            '& svg': {
                width: 24,
                height: 24,
            },
        },
        checked: {},
    }))(Checkbox);

    //  @ts-ignore
    const FilterSections = withStyles(styles)((props) => {
        //  @ts-ignore
        const { classes } = props;
        return filters.map((section: IFiltersList, sectionIndex) => {
            return (
                <Typography variant="body1" key={section.key}>
                    <Typography variant="h6" className={classes.FilterMainTitle}>
                        {t(section.label)}
                    </Typography>
                    <FormGroup style={{ margin: '1.5625rem 0' }}>
                        {section.filters.map((filterOption: FilterOption, filterOptionIndex) => {
                            return (
                                <FormControlLabel
                                    style={{ marginLeft: '1rem', position: 'relative' }}
                                    key={filterOption.key}
                                    control={
                                        <CustomCheckbox
                                            checked={filterOption.checked}
                                            onChange={() => {
                                                let newFilters = filters;
                                                newFilters[sectionIndex].filters[filterOptionIndex].checked =
                                                    !filterOption.checked;
                                                setFilters([...newFilters]);
                                            }}
                                            color={'primary'}
                                            name={t(filterOption.key)}
                                        />
                                    }
                                    label={t(filterOption.label)}
                                    className={classes.FilterOptionLabel}
                                />
                            );
                        })}
                    </FormGroup>
                </Typography>
            );
        });
    });

    const submitFilters = () => {
        const filterResult = filters.map((item) => {
            const enabledOnes = item.filters.filter((item2) => item2.checked).map((item) => item.key);
            return {
                key: item.key,
                values: enabledOnes,
            };
        });
        setFilterState(filterResult);
        if (filterkey) {
            localStorage.setItem(filterkey, JSON.stringify(filterResult));
        }
        setFiltersOpen(false);
    };

    return (
        <>
            <FilterComponentIcon
                title={t(filterTitle || 'filters.filters')}
                onClick={() => {
                    setFiltersOpen(true);
                }}
                selectedFilterCount={renderFilterCount()}
            />
            <Dialog
                onClose={() => {
                    setFiltersOpen(false);
                }}
                aria-labelledby="customized-dialog-title"
                open={filtersOpen}
            >
                <DialogTitle
                    id="customized-dialog-title"
                    onClose={() => {
                        setFiltersOpen(false);
                    }}
                >
                    {t('filters.filters')}
                    <ClearFiltersButton filters={filters} setFilters={setFilters} t={t} />
                </DialogTitle>

                <DialogContent dividers>
                    <FilterSections />
                </DialogContent>
                <div className={Styles.FiltersFooterButtonsDiv}>
                    <button onClick={() => setFiltersOpen(false)}>{t('forms.buttons.cancel')}</button>

                    <button onClick={submitFilters}>{t('forms.buttons.applyfilters')}</button>
                </div>
            </Dialog>
        </>
    );
};

export default FilterComponent;
